module.exports = __webpack_public_path__ + "img/vehicle.05441a87.png";